import React from "react";
import { DateRange } from "react-date-range";
import { enUS } from "date-fns/locale";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const CustomDateModal = ({ show, onClose, onApply }) => {
  const [range, setRange] = React.useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: 20,
          borderRadius: 12,
          boxShadow: "0 0 20px rgba(0,0,0,0.2)",
        }}
      >
        <DateRange
          ranges={range}
          onChange={(item) => setRange([item.selection])}
          moveRangeOnFirstSelection={false}
          months={2}
          direction="horizontal"
          locale={enUS}
        />

        <div className="text-end mt-3">
          <button className="btn btn-secondary me-2" onClick={onClose}>
            Close
          </button>

          <button
            className="btn btn-primary"
            onClick={() =>
              onApply(
                formatDate(range[0].startDate),
                formatDate(range[0].endDate)
              )
            }
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomDateModal;
